export default __webpack_public_path__ + "static/media/error-404.b2ce2159.svg";